import Axios from 'axios'

import {
  standardizeOrderFromResponse,
  MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing,
} from '@/services/Standardizers'
import { getCustomer } from '@/services/FramedCheckout/customerServices'

import { log, error } from '@/services/Log'
import { FEATURE_TOGGLES } from '@/services/Configuration'
import { roundToNDigits } from '@/helpers'
import { getCookieByName } from '@/helpers/common'

const isLoyaltyProgramEnabled = FEATURE_TOGGLES?.isLoyaltyProgramEnabled

const isLoyaltyCookieEnabled = () => {
  try {
    const rewardsEnabled = getCookieByName('enableRewards') === 'true'
    return rewardsEnabled
  } catch (e) {
    log(e)
  }
  return false
}

export function loyaltyInit() {
  return new Promise(async (resolve, reject) => {
    try {
      const shopTokenInitResponse = await window.shoptoken.initCheckoutConfirmationPage()
      resolve({ success: true, response: shopTokenInitResponse })
    } catch (err) {
      reject(new Error(`shopTokenInitCheckoutConfirmationPage Failed ${err}`))
    }
  })
}
export function showLoyaltySignUpOffer({ success }) {
  return new Promise(async (resolve, reject) => {
    if (!success) {
      reject(new Error('Failed to initialize order confirmation '))
    }
    try {
      const offerResponse = await window.shoptoken.getSignupOffer()
      resolve(offerResponse)
    } catch (err) {
      reject(new Error(`shopTokenShowSignUpOffer Failed ${err}`))
    }
  })
}

export async function displayLoyaltyProgramSignup() {
  if (!isLoyaltyCookieEnabled() && !isLoyaltyProgramEnabled) {
    return { success: false }
  }
  document.dispatchEvent(new Event('displayLoyaltyProgramSignup'))
  return { success: true }
}

export const convertShopTokenToStoreCredit = (amountToRedeem) => (
  new Promise(async (resolve) => {
    setTimeout(() => resolve({ success: false }), 30000) // timeout of 30s
    try {
      const redeemCredits = window?.shoptoken?.redeemStoreCredits
      log('redeemLoyaltyBalance', { redeemCredits })
      const response = await redeemCredits(amountToRedeem)
      resolve({ success: true, response })
    } catch (e) {
      error(e)
    }
    resolve({ success: false })
  }))

export const applyStoreCreditToCheckout = async (order) => {
  try {
    const { data } = await Axios.post(
      `/api/storefront/checkouts/${order?.cart?.id}/store-credit?include=consignments.availableShippingOptions`,
    )
    return standardizeOrderFromResponse({ bigcResponse: data, order })
  } catch (e) {
    error(e)
  }
  return { success: false }
}
export async function redeemLoyaltyBalance({ order, amountToRedeem, customer }) {
  log('redeemLoyaltyBalance', { order, amountToRedeem, customer })
  if (!(isLoyaltyCookieEnabled() || isLoyaltyProgramEnabled) || !window?.shoptoken) {
    log('redeemLoyaltyBalance FAILED', { isLoyaltyOn: (isLoyaltyCookieEnabled() || isLoyaltyProgramEnabled), hasShopToken: !window?.shoptoken })
    return { success: false }
  }
  try {
    const currentStoreCredit = roundToNDigits(customer?.storeCreditAmounts?.[0]?.amount)
    const zGoldsToSell = roundToNDigits(amountToRedeem - parseFloat(currentStoreCredit))
    log(`amountToRedeem ${amountToRedeem} - currentStoreCredit ${currentStoreCredit}  = zGoldsToSell ${zGoldsToSell}`)
    if (zGoldsToSell > 0) {
      await convertShopTokenToStoreCredit(zGoldsToSell)
    }

    const newOrder = await applyStoreCreditToCheckout(order)

    const newCustomer = await getCustomer({ customerId: order?.cart.customerId })

    log('redeemLoyaltyBalance Finished', { success: true, newOrder, newCustomer })
    return { success: true, newOrder, newCustomer }
  } catch {
    error('Error in applying store credit')
  }
  return { success: false }
}

export async function getLoyaltyBannerInfo() {
  let offerDetails // the object returned from shoptoken sdk's getSignUpOffer method
  if (window.shoptoken?.isCustomerInLoyaltyProgram?.() === true) {
    return {
      success: true,
    }
  }
  try {
    await window.shoptoken.setConfig({ useCustomSignUpFlow: true })
    await window.shoptoken.initCheckoutConfirmationPage()
    offerDetails = await window.shoptoken.getSignUpOffer()
  } catch (err) {
    error('Error getting loyalty program sign up info', err)
  }
  if (offerDetails?.initialBonus) {
    return {
      success: true,
      offer: {
        logoUrl: `${window.location.origin}/__statics/images/z-rewards-logo.svg`,
        coinName: 'Z Gold',
        initialBonus: offerDetails.initialBonus,
        termsAndConditionsUrl: `${window.location.origin}/t-z-rewards-terms-and-conditions`,
      },
    }
  }
  return { success: false }
}

export async function removeStoreCredit(order) {
  log('removeStoreCredit', { order })
  try {
    const { data } = await Axios.delete(
      `/api/storefront/checkouts/${order?.cart?.id}/store-credit?include=consignments.availableShippingOptions`,
    )
    const newOrder = standardizeOrderFromResponse({ bigcResponse: data, order })
    await MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing({ order: newOrder })
    log('removeStoreCredit END', { success: true, newOrder })
    return { success: true, newOrder }
  } catch (e) {
    log('removeStoreCredit FAILED', { error: e })
    error(e)
  }
  return { success: false }
}

export const isCustomerInLoyaltyProgram = async () => {
  const isCustomerInLoyalty  = await window?.shoptoken?.isCustomerInLoyaltyProgram?.()
  return !!isCustomerInLoyalty
}
